import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RequestAccess from "@/pages/RequestAccess";

// Employer-only access: Hero signups now join the employer waitlist.
export const Route = createFileRoute("/hero-benefits-enroll")({
  head: () => seoHead("/hero-benefits-enroll"),
  component: () => <RequestAccess source="hero-benefits-enroll" hero />,
});
